export default (value) => {
  const time = new Date(value)
  return time.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', hour12: false })
}
